import * as React from 'react';

import { Binding } from 'core/infrastructure';

export type DataGridColumnFormatter<T> = (value: any, item: T) => string;

export interface DataGridColumn<T> {
	title: string;

	linkTo: Binding.PropertyPath<T>;
	format?: DataGridColumnFormatter<T>;

	// URL (opcional) a la que se navega al pulsar en la celda
	href?: (value: any, item: T) => Nullable<string>;

	// Estilos CSS para la cabecera y las celdas individuales
	headerClassName?: string;
	cellClassName?: string;

	// Ancho en píxels y factor de crecimiento al rellenar
	width?: number;
	flexGrow?: number;

	// Elementos a incluir como contenido de cada celda
	cellChildren?: (value: any, item: T) => React.ReactNode[];

	// Mantener posición de la columna al hacer scroll
	fixed?: boolean;

	// Calcular total para la columna al exportar tabla a excel
	totalize?: 'sum' | 'avg' | 'count';

	showTotalizeFooter?: boolean;

	// Formatear la columna del footer como hora (hh:mm) al exportar tabla a excel
	showFooterAsHours?: boolean;

	// Permite controlar si la columna es visible. Si no se indica nada, lo será
	isVisible?: boolean;

	// Permite controlar si la columna es ajustable en anchura. Si no se indica nada, lo será
	isResizable?: boolean;

	editable?: boolean;

	cellConstraint?: CellConstraint<T> | CellConstraint<T>[];
}

const defaultFormat = function <T>(value: any, _item: T): string {
	return value === null || typeof value === 'undefined' ? '' : value.toString();
};

export const applyColumnFormat = function <T>(col: DataGridColumn<T>, value: any, item: T) {
	return col.format ? col.format(value, item) : defaultFormat(value, item);
};

export const applyFormat = function <T>(format: DataGridColumnFormatter<T> | undefined, value: any, item: T) {
	return format ? format(value, item) : defaultFormat(value, item);
};

export type CellConstraint<T> = (value: any, item: T) => string;
